import { fetchConstants, FETCH_WRITE_TYPES } from '../_constants';

let requests = 0;
let creat = 0;

const isWrite = (type) => FETCH_WRITE_TYPES.indexOf(type) >= 0;

const removePending = (list = [], payload) => {
    if (!list.length) return [];
    if (payload && payload.id != null) {
        return list.filter((item) => item.id !== payload.id);
    }
    if (payload && payload.resource) {
        const index = list.findIndex((item) => (
            item.resource === payload.resource && item.type === payload.type
        ));
        if (index < 0) return list;
        return list.filter((_, i) => i !== index);
    }
    return list;
};

const keepAfterAbort = (list = [], all) => list.filter((item) => {
    if (!item) return false;
    if (isWrite(item.type)) return true;
    return !all && item.persist;
});

export function fetch(state = { loading: 0, creat: 0, pending: [] }, action) {
    const pending = state.pending || [];
    switch (action.type) {
        case fetchConstants.START: {
            requests += 1;
            const payload = action.payload || {};
            return {
                loading: requests,
                creat,
                pending: pending.concat([{
                    id: payload.id,
                    type: payload.type,
                    resource: payload.resource,
                    persist: !!payload.persist,
                }]),
            };
        }
        case fetchConstants.CREATE:
            creat += 1;
            return { loading: requests, creat, pending };
        case fetchConstants.CREATE_END:
            creat = Math.max(0, creat - 1);
            return { loading: requests, creat, pending };
        case fetchConstants.ERROR: {
            const next = removePending(pending, action.payload);
            requests = Math.max(0, next.length);
            return {
                loading: requests,
                creat,
                pending: next,
            };
        }
        case fetchConstants.SUCCESS: {
            const next = removePending(pending, action.payload);
            requests = Math.max(0, next.length);
            return {
                loading: requests,
                creat,
                pending: next,
            };
        }
        case fetchConstants.ABORT: {
            const all = action.payload && action.payload.all;
            const next = keepAfterAbort(pending, all);
            requests = next.length;
            return {
                loading: requests,
                creat,
                pending: next,
            };
        }
        default:
            return state;
    }
}
